/**
 * Declares the role-gated hierarchy rendered by the application side menu.
 */
import appRoles from "./auth/roles-info";

export const navigation = [
	{
		text: "Home",
		path: "/home",
		icon: "home",
		permission: appRoles.anonymous.name,
	},
	{
		text: "Admin",
		icon: "folder",
		permission: appRoles.anonymous.name,
		items: [
			{
				text: "Logs",
				path: "/logs",
			},
		],
	},
	{
		text: "Email",
		icon: "folder",
		permission: appRoles.bulkEmailAdmin.name,
		items: [
			{
				text: "Bulk Email Settings",
				path: "/bulk-email-settings",
				permission: appRoles.bulkEmailAdmin.name,
			},
			{
				text: "Network Locations",
				path: "/network-location-settings",
				permission: appRoles.admin.name,
			},
			{
				text: "Archived Emails",
				path: "/archived-emails",
				permission: appRoles.bulkEmailAdmin.name,
			},
		],
	},
	{
		text: "Settings",
		icon: "folder",
		permission: appRoles.admin.name,
		items: [
			{
				text: "API",
				path: "/api-settings",
			},
			{
				text: "Attachments",
				path: "/attachment-settings",
			},
			{
				text: "User Admin",
				path: "/user-admin-settings",
			},
		],
	},
];
